import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SETTINGS} from "../config/common.settings";

@Injectable({
  providedIn: 'root'
})
export class ImageApiService {
  pexelsImages: any;
  onpexelsImagesChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient) {
  }

  getPexelsImages(text: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/image/pexels/${text}`)
        .subscribe({
          next: (response: any) => {
            this.pexelsImages = response;
            this.onpexelsImagesChange.next(this.pexelsImages);
            resolve(this.pexelsImages);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
